// Geteilte Eingabe-Helfer der Finanzplanung: Euro-Beträge als Text-Inputs
// mit de-Format (Muster logbook.tsx) — type=number würde „12,50" stumm
// verwerfen (Review-Fund Paket 1).

/** Cents → Eingabewert mit de-Komma; 0 → leeres Feld. */
export function centsToInput(cents: number): string {
  return cents === 0 ? '' : (cents / 100).toFixed(2).replace('.', ',')
}

/**
 * de-Eingabe normalisieren (Review-Fund Paket 2: „2.500" wurde als 2,50 €
 * geparst — 1000×-Korruption):
 *  - mit Komma sind ALLE Punkte Tausendertrenner („1.234,56")
 *  - ohne Komma sind Punkte nur im echten Tausender-Muster Trenner
 *    („1.200", „12.345.678"); „2.5" bleibt Dezimalpunkt
 */
function normalizeDe(value: string): string {
  const t = value.trim()
  if (t.includes(',')) return t.replace(/\./g, '').replace(',', '.')
  if (/^-?\d{1,3}(\.\d{3})+$/.test(t)) return t.replace(/\./g, '')
  return t
}

/** Eingabewert → Cents; de-Format normalisiert; null bei unbrauchbarer
 *  Eingabe (Aufrufer resettet dann auf den letzten gültigen Wert). */
export function parseCents(value: string): number | null {
  const t = normalizeDe(value)
  if (t === '') return 0
  const n = Number(t)
  if (!Number.isFinite(n) || n < 0) return null
  return Math.round(n * 100)
}

/** Ganzzahl-Eingabe (Alter, Jahre). */
export function parseIntInput(value: string, fallback: number): number {
  const n = Number(value.trim())
  return Number.isFinite(n) && Number.isInteger(n) ? n : fallback
}

/** Dezimal-Eingabe mit de-Format (Entgeltpunkte, Prozentwerte);
 *  leeres Feld = fallback — NICHT 0 (Review-Fund: Number('') === 0). */
export function parseDecimalInput(value: string, fallback: number): number {
  const t = normalizeDe(value)
  if (t === '') return fallback
  const n = Number(t)
  return Number.isFinite(n) ? n : fallback
}
